import { Button } from '@cian/ui-kit';

import { type FC, type SyntheticEvent } from 'react';

import { type PaginationItem } from '../../../../types/pagination';

import styles from './Pagination.css';

type PaginationProps = {
  prevButton: PaginationItem;
  nextButton: PaginationItem;
  onClick(e: SyntheticEvent<HTMLButtonElement>, page: PaginationItem): void;
  pages: PaginationItem[];
};

export const Pagination: FC<PaginationProps> = props => {
  const { nextButton, onClick, pages, prevButton } = props;

  return (
    <nav className={styles['pagination']} data-testid="listing.pagination">
      {[prevButton, ...pages, nextButton].map(pageButton => (
        <Button
          data-testid="listing.pagination-button"
          disabled={pageButton.disabled}
          key={pageButton.id}
          theme={pageButton.disabled ? 'fill_primary' : 'stroke_secondary'}
          onClick={(event): void => onClick(event, pageButton)}
        >
          {pageButton.title}
        </Button>
      ))}
    </nav>
  );
};
